import React from 'react';
import { DropTarget, DragSource } from 'react-dnd';
import { findDOMNode } from 'react-dom';
import flow from 'lodash/flow';
import Field from './Field.react';
import FieldImage from './FieldImage.react';
import HtmlToReact from 'html-to-react';
import ButtonAreaDelete from './ButtonAreaDelete.react';

const style = {
    opacity: 0,
    cursor: 'auto'
};

const areaElementSource = {

    beginDrag(props, monitor, component) {
        return {
            id: props.id,
            index: props.index,
            source: 'areaElement'
        };
    },

    endDrag(props, monitor) {
    },

    canDrag(props, monitor) {

        if (props.area.sortable) {
            return true;
        }

        return false;
    }
};

const areaElementTarget = {

    hover(props, monitor, component) {

        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        const dragAreaId = monitor.getItem().id;
        const hoverAreaId = props.id;

        // handle only sortable elements with source "areaElement"
        if (monitor.getItem().source !== 'areaElement') {
            return;
        }

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        const clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%

        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        // Sortable only on same are
        if (dragAreaId === hoverAreaId) {

            // Time to actually perform the action
            props.moveAreaElement(dragIndex, hoverIndex);

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            monitor.getItem().index = hoverIndex;
        }
    }
};

class AreaElement extends React.Component {

    static get defaultProps() {
        return {
            ConfiguratorManager: {},
            area: null,
            data: {},
            layoutElement: null,
            isTable: false,
            sessionUser: null,
        }
    }

    render() {

        const { isDragging, connectDragSource, connectDropTarget, canDrag, appConfig } = this.props;
        const opacity = isDragging ? 0 : 1;
        const cursor = canDrag ? 'move' : 'auto';

        const { ConfiguratorManager, area, layoutElement, areaElement, index, documentStorage, editField, isTable, sessionUser, removeAreaElement } = this.props;

        // merge Data in hierarchical order
        const mergedData = {...areaElement.data.contentElement, ...areaElement.data.document, ...areaElement.data.documentStorage};

        let html = '<div class="configurator-area-element">';

        if(mergedData.type=='general_content_element'){
            html +='<div style="text-align:center; padding:15%; padding-top:20px;">'+mergedData.message+'</div>';
        }else{
            html += this._prepareElement(layoutElement, area);
        }
        html += '</div>';

        // is element deletable
        // if area deletable setting is true - all elements can be deletable, otherwise only the added elements by sessionUser
        let isDeletable = false;
        if (area && area.deletable === true) {
            isDeletable = true;
        } else if (area && area.deletable === false && sessionUser && sessionUser.userId && areaElement &&
            areaElement.createdBy && (areaElement.createdBy.toString() === sessionUser.userId.toString())) {
            isDeletable = true;
        }

        var isValidNode = function() {
            return true;
        };
        var processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
        var processingInstructions = [
            {
                // Processing editable fields
                shouldProcessNode: function(node) {
                    return (this.isImageField(node) || this.isTextField(node) || this.isPriceField(node)) ? true : false;
                },

                // Replaced predpared nodes by components
                processNode: function(node, children) {

                    if (this.isImageField(node)) {
                      return this.processImageField(node);
                    } else if (this.isCheckboxField(node)) {
                      return this.processCheckboxField(node)
                    } else if (this.isPriceField(node)) {
                      return this.processPriceField(node)
                    } else if (this.isTextField(node)) {
                      return this.processTextField(node)
                    }
                },

                // replace prepared node by Field component
                processTextField(node) {

                    let editable = false;
                    let formKey = null;
                    let formType = 'text';
                    let formValue = ''; // undefined form value

                    if (node.parent && node.parent.attribs && node.parent.attribs.class &&
                        node.parent.attribs.class.includes('editable')) {
                        editable = true;
                    }

                    if (node.data) {
                        formKey = node.data;
                    }

                    if (mergedData[`${formKey}`]) {
                        formValue = mergedData[`${formKey}`];
                    }

                    return <Field key={area.id + formKey}
                                  formKey={formKey}
                                  formType={formType}
                                  index={index}
                                  formValue={formValue}
                                  editable={editable}
                                  ConfiguratorManager={ConfiguratorManager}
                                  editField={editField}
                                  area={area} />
                },

                // replace prepared image by FieldImage component
                processImageField(node) {

                    let formKey = node.attribs['data-imagekey'];

                    // set default attrubites, from global appConfig
                    let formValue = appConfig.configuratorFallbackImageSrc ? appConfig.configuratorFallbackImageSrc : '/theme/images/blankpix-gray.png';
                    let height = appConfig.configuratorFallbackImageHeight ? appConfig.configuratorFallbackImageHeight : 50;
                    let width = appConfig.configuratorFallbackImageWidth ? appConfig.configuratorFallbackImageWidth : 80;
                    let alt = '';
                    let cssClass = 'element-image';

                    // overwrite values
                    if (mergedData[`${formKey}`]) {
                        formValue = mergedData[`${formKey}`];
                        if (node.attribs.height) {
                            height = node.attribs.height;
                        } else {
                            height = null;
                        }
                        if (node.attribs.width) {
                            width = node.attribs.width;
                        } else {
                            width = null;
                        }
                        if (node.attribs.alt) {
                            alt = node.attribs.alt;
                        } else {
                            alt = null;
                        }
                        if (node.attribs.class) {
                            cssClass = cssClass + ' ' + node.attribs.class;
                        } else {
                            cssClass = null;
                        }
                    }

                    return <FieldImage
                            key={area.id + formKey}
                            src={ formValue }
                            alt={ alt }
                            width={ width }
                            height={ height }
                            cssClass={ cssClass }
                        />
                },

              // replace prepared node by Field component
              processPriceField(node) {

                let editable = false;
                let formKey = null;
                let formType = 'price';
                let formValue = ''; // undefined form value

                if (node.parent && node.parent.attribs && node.parent.attribs.class &&
                  node.parent.attribs.class.includes('editable')) {
                  editable = true;
                }

                if (node.data) {
                  formKey = node.data;
                }



                if (mergedData[`${formKey}`]) {
                  formValue = mergedData[`${formKey}`];
                }


                return <Field key={area.id + formKey}
                              formKey={formKey}
                              formType={formType}
                              index={index}
                              formValue={formValue}
                              editable={editable}
                              ConfiguratorManager={ConfiguratorManager}
                              editField={editField}
                              area={area} />
                },

              // replace prepared node by Field component
              processCheckboxField(node) {

                let editable = false;
                let formKey = null;
                let formType = 'checkbox';
                let formValue = ''; // undefined form value

                if (node.parent && node.parent.attribs && node.parent.attribs.class &&
                  node.parent.attribs.class.includes('editable')) {
                  editable = true;
                }

                if (node.data) {
                  formKey = node.data;
                }

                if (mergedData[`${formKey}`]) {
                  formValue = mergedData[`${formKey}`];
                }

                return <Field key={area.id + formKey}
                              formKey={formKey}
                              formType={formType}
                              index={index}
                              formValue={formValue}
                              editable={editable}
                              ConfiguratorManager={ConfiguratorManager}
                              editField={editField}
                              area={area} />
              },

                isImageField(node) {
                    return node.name === 'img' && node.attribs['data-imagekey'];
                }
                ,
                isTextField(node) {
                    return node.parent && node.parent.name && node.parent.name === 'span' && node.parent.attribs &&
                        node.parent.attribs.class && node.parent.attribs.class.includes('element-field');
                },
                isPriceField(node) {
                    return node.parent && node.parent.name && node.parent.name === 'span' && node.parent.attribs &&
                        node.parent.attribs.class && node.parent.attribs.class.includes('element-field') && node.parent.attribs.class.includes('type-price');

                },
                isCheckboxField(node) {
                    return node.parent && node.parent.name && node.parent.name === 'span' && node.parent.attribs &&
                      node.parent.attribs.class && node.parent.attribs.class.includes('element-field') && node.parent.attribs.class.includes('type-checkbox');
                }
            },
            {
                // Processing root node
                shouldProcessNode: function(node) {
                    return node.type && node.type === 'tag' && node.name && node.name === 'div' && node.attribs &&
                        node.attribs.class && node.attribs.class === 'configurator-area-element';
                },

                processNode: function(node, children) {

                    let className = 'configurator-area-element';
                    if (isTable) {
                        className += ' area-table-row';
                    }
                    if (mergedData.type) {
                        className += ' configurator-area-element-content-type-' + mergedData.type;
                    }

                    let deleteButton;
                    if (isDeletable) {
                        if (isTable) {
                            deleteButton = <div className="area-table-cell"><ButtonAreaDelete index={index} removeAreaElement={removeAreaElement} /></div>
                        } else {
                            deleteButton = <ButtonAreaDelete index={index} removeAreaElement={removeAreaElement} />
                        }
                    }

                    return <div className={className}>
                        { children }
                        { deleteButton }
                    </div>;

                }
            },
            {
                // Anything else
                shouldProcessNode: function(node) {
                    return true;
                },
                processNode: processNodeDefinitions.processDefaultNode
            }];

        const htmlToReactParser = new HtmlToReact.Parser(React);
        const parsedElement = htmlToReactParser.parseWithInstructions(html, isValidNode, processingInstructions);

        return connectDragSource(connectDropTarget(
                parsedElement
        ));
    }

    /**
     * Prepare element and decorate template placeholder with special span tag
     *
     * @param layoutElement
     * @param data
     * @param area
     */
    _prepareElement(layoutElement, area) {

        // if no layoutElement given, render empty string
        if (!layoutElement) {
            return '';
        }

        // replace image attributes
        layoutElement = layoutElement.replace(/<img(.*?)src="{{(.*?)}}"(.*)>/g, function (match, $1, $2, $3) {
            const dataKey =  $2.trim();
            return '<img ' + $1.trim() +
                    ' data-imagekey="' + dataKey + '"' + $3.trim() + '>';
        });

        // decorate template vars with contenteditable tag
        layoutElement = layoutElement.replace(/({{)(.*?)(}})/g, function (match, $1, $2, $3) {
            let className = 'element-field';
            let dataKey =  $2.trim();

            // maybe keyNames includes an fieldType (e.g. price) - like priceSmallSize:price
            // so we have to use only the first segment of the name (without the type)
            if (dataKey) {
              const _dataKeySplit = dataKey.split(":");
              if (_dataKeySplit && _dataKeySplit.length === 2) {
                  dataKey = _dataKeySplit[0];
                  className = className + ' type-' + _dataKeySplit[1];
              }
            }

            if (area.editable && area.editable === true) {
                className = className + ' editable';
            } else if (area.editable && area.editable.length > 0) {
                let editable = false;
                area.editable.map(function (editableEntry) {
                   if (editableEntry === dataKey) {
                       editable = true;
                   }
                });
                if (editable) {
                    className = className + ' editable';
                }
            }

            return '<span class="' + className + '">' + dataKey + '</span>';
        });

        return layoutElement ;
    }
}

// export default AreaElement;
export default flow(
    DragSource('CONFIGURATOR_DND', areaElementSource, (connect, monitor) => ({
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        // You can ask the monitor about the current drag state:
        isDragging: monitor.isDragging(),
        canDrag: monitor.canDrag(),
    })),
    DropTarget('CONFIGURATOR_DND', areaElementTarget, connect => ({
        connectDropTarget: connect.dropTarget()
    }))
)(AreaElement);



// WEBPACK FOOTER //
// ./src/js/components/configuratorElements/AreaElement.react.jsx